import { useAuthContext } from 'src/Core/hooks/AuthContext';

export type ReportAudience = 'internal' | 'customer';

export interface MaelabordReportConfig {
  name: string;
  path: string;
  audience: ReportAudience;
}

// Single source of truth for which Mælaborð reports exist, their audience, and
// their sidebar label — consulted by both the page-level AuthorizationGuard and
// the sidebar nav (LayoutCore.tsx) so a new report can't ship ungated or with a
// mismatched name, and so internal/customer reports can be split into separate
// nav sections later without touching gating logic.
export const MAELABORD_REPORTS = {
  wrapped: { name: 'Wrapped', path: '/maelaboard/wrapped', audience: 'internal' },
  vanskil: { name: 'Kröfusafn og vanskil', path: '/maelaboard/vanskil', audience: 'customer' },
  innheimta: { name: 'Innheimta', path: '/maelaboard/innheimta', audience: 'customer' },
  thjonusta: { name: 'Þjónusta við greiðendur', path: '/maelaboard/thjonusta', audience: 'customer' },
  greidendur: { name: 'Greiðendagreining', path: '/maelaboard/greidendur', audience: 'customer' },
  atvinnugreinar: {
    name: 'Samanburður starfsgreina',
    path: '/maelaboard/atvinnugreinar',
    audience: 'internal',
  },
  demo: { name: 'Demoskýrsla', path: '/maelaboard/demo', audience: 'internal' },
} as const satisfies Record<string, MaelabordReportConfig>;

export type MaelabordReportKey = keyof typeof MAELABORD_REPORTS;

export function useMaelabordReportAccess(key: MaelabordReportKey): boolean {
  const { isInternalUser, hasAccessToDashboards } = useAuthContext();
  return MAELABORD_REPORTS[key].audience === 'internal' ? isInternalUser : hasAccessToDashboards;
}
